
import  React, {useLayoutEffect, useState} from "react";
import { DivCounter, StadisticsContainer } from "./counterComponents";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";

const Counter = (props) => {

    const [activeCount, setActiveCount] = useState(false);
    const [isMobile, setIsMobile] = useState(false);


    useLayoutEffect(() => {

        if(typeof window !== "undefined"){

                        
            const activateSensor = () => {

                console.log(window.scrollY);    
                if(window.scrollY > 2600 && !activeCount){
                    setActiveCount(true);
                    console.log("removiendo evento");
                    window.removeEventListener("scroll",activateSensor);
                }
            }

            const consultWidth = () => {
                
                if(window.screen.width > 768){
                    setIsMobile(false);
                }else{
                    setIsMobile(true);
                }
            };

            window.addEventListener("scroll",activateSensor);
            window.addEventListener("resize",consultWidth);
        }
    },[]);
    
    const onChange = (start) => {

        console.log("probando active count ",activeCount);
        if(typeof start === "function"){
            
            if(activeCount){
                setActiveCount(false);
                console.log("probando active count ",activeCount);
            }
        }
    }
    return(
        <>
            <StadisticsContainer portrait={props.portrait}>

                <div class="wrapper">
                    <DivCounter>
                           <div class="container">
                                <div class="info-row">
                                    <div class="icon">
                                        <span class="icon-iconos_Mesa-de-trabajo-1"></span>
                                    </div>

                                    <div class="title-logo"
                                         style={!isMobile ? {width: "33% !important"} : {}}                >
                                        <h1>+ <CountUp start={0} end={20} redraw={true} duration={3}>
                                                {({ countUpRef, start }) => (
                                                <VisibilitySensor onChange={onChange(start)} delayedCall
                                                active={activeCount}>
                                                    <span ref={countUpRef} />
                                                </VisibilitySensor>
                                                )}
                                            </CountUp></h1>
                                    </div>
                                </div>

                                <div class="info-row">
                                    <h4>AÑOS DE EXPERIENCIA</h4>
                                </div>
                            </div>
                    </DivCounter>

                    <DivCounter>
                        <div class="container">
                            <div class="info-row">
                                <div class="icon">
                                    <span class="icon-intervenciones-electivas"></span>
                                </div>
                                <div class="title-logo">
                                    <h1>+ <CountUp start={100} end={580000} redraw={true}>
                                                {({ countUpRef, start }) => (
                                                <VisibilitySensor onChange={onChange(start)} delayedCall active={activeCount}>
                                                    <span ref={countUpRef} />
                                                </VisibilitySensor>
                                                )}
                                            </CountUp></h1>
                                </div>
                            </div>

                            <div class="info-row">
                                <h4>INTERVENCIONES ELECTIVAS</h4>
                            </div>
                        </div>
                    </DivCounter>

                    <DivCounter>
                        <div class="container">
                            <div class="info-row">
                                <div class="icon">
                                    <span class="icon-casos-resueltos-"></span>
                                </div>
                                <div class="title-logo">
                                    <h1>+ <CountUp start={0} end={9500} redraw={true}>
                                                {({ countUpRef, start }) => (
                                                <VisibilitySensor onChange={onChange(start)} delayedCall active={activeCount}>
                                                    <span ref={countUpRef} />
                                                </VisibilitySensor>
                                                )}
                                            </CountUp></h1>                            
                                </div>
                            </div>

                            <div class="info-row">
                                <h4>CASOS RESUELTOS</h4>
                            </div>
                        </div>
                    </DivCounter>
                </div>

            </StadisticsContainer>
        </>
    );
};

export default Counter;